import React from "react";
import { Formik, Form } from "formik";
import { Stack } from "office-ui-fabric-react";
import { useTranslation } from "react-i18next";

import PanelHeader from "../../../common/layout/PanelHeader";
import NewFormField from "../../../common/layout/form/NewFormField";
import ActivityIndicator from "../../../common/layout/ActivityIndicator";
import NewFormBtns from "../../../common/layout/form/NewFormBtns";
import MessageContainer from "../../../auth/components/register/forms/MessageContainer";
import { useSelfEditForm } from "../../hooks/useSelfEditForm";

const SelfEditForm: React.FC = () => {
  const { cancelForm, handleSubmit } = useSelfEditForm();
  const { t } = useTranslation("admin");

  return (
    <Formik initialValues={{}} onSubmit={handleSubmit}>
      {({ handleSubmit }) => (
        <Form translate="yes" onSubmit={handleSubmit}>
          <Stack>
            <PanelHeader text={t("nav.editProfile") as string} />
            <NewFormField name="lastName" label={t("nav.colLastName") as string} />
            <NewFormField name="firstName" label={t("nav.colFirstName") as string} />
            <NewFormField name="phone" label={t("nav.colPhone") as string} />
            <NewFormField name="email" label={t("nav.colEmail") as string} />
            <NewFormBtns
              cancelForm={cancelForm}
              submitBtnText={t("nav.save") as string}
              disabled={false}
            />
          </Stack>
          {false ? <ActivityIndicator /> : <MessageContainer />}
        </Form>
      )}
    </Formik>
  );
};

export default SelfEditForm;
